import script from "./Picture.vue?vue&type=script&setup=true&lang=js"
export * from "./Picture.vue?vue&type=script&setup=true&lang=js"

import "./Picture.vue?vue&type=style&index=0&id=488ccf94&lang=scss&scoped=true"

import exportComponent from "E:\\xm\\siggraph\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-488ccf94"]])

export default __exports__